/**
 * edj-3d-dialog.js
 * Handler léger du dialog 3D / AR
 * Item 8 (VAGUE 3) — Refactor lazy-load (VAGUE 4) — EDJ Shopify theme
 *
 * Triggers :
 *   - [data-edj-open-3d] (bouton "Voir en 3D / AR" sous l'image)
 * Cible : le dialog #edj-3d-dialog-<productId>, contenant un .edj-3d-dialog__stage
 * vide. Au click, on crée dynamiquement <model-viewer> avec les data-* du bouton.
 *
 * Comportement (VAGUE 4 — lazy-load) :
 *   - Au load : aucun <model-viewer> dans le DOM → pas de fetch .glb
 *   - Click bouton → création dynamique de <model-viewer> + showModal()
 *   - Click backdrop ou ✕ ou Esc → close + suppression du <model-viewer>
 *     (libération mémoire / arrêt téléchargement si encore en cours)
 *
 * Sécurité : sources via setAttribute(url) — les URLs proviennent des sources
 * Shopify model.sources, déjà escapées. Pas d'innerHTML avec données utilisateur.
 */
(function () {
  'use strict';

  function injectStyles() {
    if (document.getElementById('edj-3d-dialog-style')) return;
    const style = document.createElement('style');
    style.id = 'edj-3d-dialog-style';
    style.textContent = [
      '.edj-3d-dialog{padding:0;border:0;background:transparent;width:90vw;max-width:1100px;}',
      '.edj-3d-dialog::backdrop{background:rgba(20,16,12,.85);}',
      '.edj-3d-dialog__inner{position:relative;background:#fff;border-radius:6px;overflow:hidden;}',
      '.edj-3d-dialog__close{position:absolute;top:8px;right:8px;z-index:2;width:36px;height:36px;border-radius:50%;border:0;background:rgba(20,16,12,.7);color:#fff;font-size:18px;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;}',
      '.edj-3d-dialog__close:hover{background:rgba(20,16,12,.9);}',
      '.edj-3d-dialog__stage{position:relative;aspect-ratio:1/1;background:#f7f4ee;}',
      '.edj-3d-dialog__stage > model-viewer{width:100%;height:100%;display:block;}'
    ].join('');
    document.head.appendChild(style);
  }

  function createModelViewer(btn) {
    const src = btn.getAttribute('data-model-src') || '';
    const iosSrc = btn.getAttribute('data-model-ios-src') || '';
    const alt = btn.getAttribute('data-model-alt') || '';
    const poster = btn.getAttribute('data-model-poster') || '';
    if (!src) return null;

    const mv = document.createElement('model-viewer');
    mv.setAttribute('src', src);
    if (iosSrc) mv.setAttribute('ios-src', iosSrc);
    if (alt) mv.setAttribute('alt', alt);
    if (poster) mv.setAttribute('poster', poster);
    // Comportements model-viewer / Shopify standard
    mv.setAttribute('reveal', 'auto');
    mv.setAttribute('camera-controls', '');
    mv.setAttribute('auto-rotate', '');
    mv.setAttribute('ar', '');
    mv.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
    mv.setAttribute('loading', 'eager');
    mv.setAttribute('interaction-prompt', 'auto');
    return mv;
  }

  function clearStage(stage) {
    while (stage && stage.firstChild) {
      // Si <model-viewer> a une méthode dispose(), l'appeler peut aider
      // à libérer GPU/textures dans certaines implémentations.
      const child = stage.firstChild;
      if (child && typeof child.dispose === 'function') {
        try { child.dispose(); } catch (e) { /* noop */ }
      }
      stage.removeChild(child);
    }
  }

  function init() {
    injectStyles();

    document.querySelectorAll('[data-edj-open-3d]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const root = btn.closest('edj-product-gallery, .edj-product-gallery, .edj-product-hero, body');
        const dlg = root ? root.querySelector('.edj-3d-dialog') : document.querySelector('.edj-3d-dialog');
        if (!dlg) return;
        const stage = dlg.querySelector('.edj-3d-dialog__stage');
        if (!stage) return;

        // Lazy-create : ne crée le <model-viewer> que si pas déjà présent
        if (!stage.querySelector('model-viewer')) {
          const mv = createModelViewer(btn);
          if (mv) stage.appendChild(mv);
        }

        if (typeof dlg.showModal === 'function') dlg.showModal();
      });
    });

    document.querySelectorAll('[data-edj-close-3d]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const dlg = btn.closest('.edj-3d-dialog');
        if (dlg && dlg.open) dlg.close();
      });
    });

    // Click backdrop = close
    document.querySelectorAll('.edj-3d-dialog').forEach(function (dlg) {
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });
      // Au close (Esc, backdrop, bouton ✕) : retire le <model-viewer> du DOM
      // pour libérer la mémoire et stopper tout chargement encore en cours.
      dlg.addEventListener('close', function () {
        const stage = dlg.querySelector('.edj-3d-dialog__stage');
        clearStage(stage);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
